<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Kasam</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Ara"
        single-line
        hide-details
        clearable
        style="max-width: 280px"
      ></v-text-field>
      <v-btn icon class="ml-2" :loading="loading" @click="load">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <v-layout wrap class="my-2 px-2">
      <v-flex xs6 sm3>
        <v-card flat class="pa-2 text-xs-center elevation-1">
          <div class="caption grey--text">Takı (adet)</div>
          <div class="title">{{ countByType(0) }}</div>
        </v-card>
      </v-flex>
      <v-flex xs6 sm3 class="pl-2">
        <v-card flat class="pa-2 text-xs-center elevation-1">
          <div class="caption grey--text">Ziynet (adet)</div>
          <div class="title">{{ qtyByType(1) }}</div>
        </v-card>
      </v-flex>
      <v-flex xs6 sm3 class="pl-2">
        <v-card flat class="pa-2 text-xs-center elevation-1">
          <div class="caption grey--text">Külçe (adet)</div>
          <div class="title">{{ qtyByType(2) }}</div>
        </v-card>
      </v-flex>
      <v-flex xs6 sm3 class="pl-2">
        <v-card flat class="pa-2 text-xs-center elevation-1">
          <div class="caption grey--text">Toplam Kalem</div>
          <div class="title">{{ lines.length }}</div>
        </v-card>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="filteredLines"
      :loading="loading"
      :rows-per-page-items="[50, 100, 500, { text: 'Tümü', value: -1 }]"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="px-2">
          <v-chip small :color="typeColor(props.item.inventoryType)" text-color="white">
            {{ props.item.inventoryTypeName }}
          </v-chip>
        </td>
        <td class="px-2">{{ props.item.productName }}</td>
        <td class="px-2">{{ props.item.weight }}</td>
        <td class="px-2">{{ props.item.purityLabel }}</td>
        <td class="px-2">{{ props.item.size || '-' }}</td>
        <td class="px-2">{{ props.item.serialNumber || '-' }}</td>
        <td class="px-2">
          <span v-if="props.item.inventoryType === 0">{{ props.item.statusName }}</span>
          <span v-else>-</span>
        </td>
        <td class="px-2 text-xs-right">{{ props.item.quantity }}</td>
      </template>
      <template v-slot:no-data>
        <div class="text-xs-center pa-4 grey--text">Üzerinize zimmetli ürün yok.</div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    lines: [],
    search: "",
    headers: [
      { text: "Tip", value: "inventoryTypeName" },
      { text: "Ürün", value: "productName" },
      { text: "Ağırlık", value: "weight" },
      { text: "Ayar", value: "purityLabel" },
      { text: "Ölçü", value: "size" },
      { text: "Seri No", value: "serialNumber" },
      { text: "Durum", value: "statusName" },
      { text: "Adet", value: "quantity", align: "right" },
    ],
  }),

  computed: {
    filteredLines() {
      const q = (this.search || "").toLocaleLowerCase("tr");
      if (!q) return this.lines;
      return this.lines.filter(l =>
        [l.productName, l.serialNumber, l.inventoryTypeName, l.purityLabel]
          .filter(Boolean)
          .some(v => v.toLocaleLowerCase("tr").includes(q))
      );
    },
  },

  created() {
    this.load();
  },

  methods: {
    typeColor(t) {
      if (t === 0) return "teal";
      if (t === 1) return "amber darken-2";
      return "blue-grey darken-1";
    },
    countByType(t) {
      return this.lines.filter(l => l.inventoryType === t).length;
    },
    qtyByType(t) {
      return this.lines.filter(l => l.inventoryType === t).reduce((s, l) => s + (l.quantity || 0), 0);
    },
    async load() {
      this.loading = true;
      try {
        this.lines = (await this.$store.dispatch("inventory/getMyZimmet")) || [];
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message =
          "Kasam yüklenemedi: " +
          ((e && e.response && e.response.data && e.response.data.message) || (e && e.message) || "");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
